import React, { useState } from "react";
// Reuse FilterPanel styles or create new one if needed. 
// User said "filter have same design like we used in other pages just options have changed"
import "../CollegeFinder/FilterPanel.css"; 
import CustomDropdown from "../CollegeFinder/CustomDropdown";

const JobFilterPanel = ({ onApply }) => {
  // Local state for UI
  const [selectedExperience, setSelectedExperience] = useState("");
  const [selectedSalary, setSelectedSalary] = useState("");
  const [selectedJobType, setSelectedJobType] = useState("");
  const [selectedRole, setSelectedRole] = useState("");

  const experienceOptions = ["Fresher", "1-3 Years", "3-5 Years", "5-8 Years", "8+ Years"];
  const salaryOptions = ["< 3 LPA", "3-6 LPA", "6-10 LPA", "10-15 LPA", "15+ LPA"];
  const jobTypeOptions = ["Full Time", "Part Time", "Contract", "Internship", "Remote"];
  const roleOptions = ["Software Developer", "Product Manager", "Designer", "Sales", "Marketing", "HR"]; // Can be fetched from API later

  const clearAllFilters = () => {
    setSelectedExperience("");
    setSelectedSalary("");
    setSelectedJobType("");
    setSelectedRole("");
  };

  const handleApply = () => {
    if (onApply) {
      onApply({
        experience: selectedExperience,
        salary: selectedSalary,
        jobType: selectedJobType,
        role: selectedRole
      });
    }
  };

  return (
    <div className="filter-main">
      <div className="filter-header">
        <h3>Filters</h3>
        <button className="remove-btn" onClick={clearAllFilters}>
          REMOVE ALL
        </button>
      </div>

      {/* Experience Filter */}
      <div className="filter-block">
        <label>Experience</label>
        <CustomDropdown
          options={experienceOptions}
          value={selectedExperience}
          onChange={setSelectedExperience}
          placeholder="Select Experience"
        />
      </div>

      {/* Salary Filter */}
      <div className="filter-block">
        <label>Salary</label>
        <CustomDropdown
          options={salaryOptions}
          value={selectedSalary}
          onChange={setSelectedSalary}
          placeholder="Select Salary"
        />
      </div>

      {/* Job Type Filter */}
      <div className="filter-block">
        <label>Job Type</label>
        <CustomDropdown
          options={jobTypeOptions}
          value={selectedJobType}
          onChange={setSelectedJobType}
          placeholder="Select Job Type"
        />
      </div>

      {/* Role Category Filter */}
      <div className="filter-block">
        <label>Role</label>
        <CustomDropdown
          options={roleOptions}
          value={selectedRole}
          onChange={setSelectedRole}
          placeholder="Select Role"
        />
      </div>

      <div className="apply-filter-parent">
        <button className="apply-filters-btn" onClick={handleApply}>
          APPLY FILTERS
        </button>
      </div>
    </div>
  );
};

export default JobFilterPanel;
